import React, { useEffect } from 'react'
import { Grid, IconButton, Typography, withStyles } from '@material-ui/core'
import styles from '../../../resources/theme/global'
import colors from '../../../assets/colors'
import Icon from '@mdi/react'
import { mdiMessageQuestion } from '@mdi/js'
import Filter from './Filter'
import { useDispatch, useSelector } from 'react-redux'
import {
  useLocation,
  useParams,
} from 'react-router-dom/cjs/react-router-dom.min'
import List from './List'
import { fetchUsers } from '../UserActions'
import { usePermissions } from '../../../hooks/usePermission'

const Users = props => {
  const dispatch = useDispatch()
  const location = useLocation()
  const { canRead } = usePermissions()
  const searchParams = new URLSearchParams(location.search)

  const permissions = useSelector(state => state.auth.permissions)
  const permissionUser = useSelector(state => state.auth.permissionUser)

  const { classes } = props

  useEffect(() => {
    dispatch(fetchUsers(searchParams))
  }, [searchParams])

  return (
    <Grid
      container
      className={classes.pageHead}
      spacing={1}
      alignItems="center"
    >
      <Grid item xs={12}>
        <Typography
          variant="h4"
          style={{ fontSize: '20px' }}
          color={colors.primary}
        >
          Usuários
          <IconButton className={classes.questionBox}>
            <a href="" target="_blank" rel="noreferrer">
              <Icon
                path={mdiMessageQuestion}
                size={1}
                color={colors.secondary}
                style={{
                  position: 'absolute',
                  top: '-10px',
                  right: '-10px',
                }}
              />
            </a>
          </IconButton>
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <Grid container>
          <Filter classes={classes} permissions={permissions} />
        </Grid>
      </Grid>

      {canRead('usuarios', permissionUser) && (
        <Grid item xs={12}>
          <List permissions={permissions} classes={classes} />
        </Grid>
      )}
    </Grid>
  )
}

export default withStyles(styles)(Users)
